







































































































import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

@Component({})
export default class PromoPackDialog extends Vue {
  @State('showPromoPackDialog') readonly showPromoPackDialogState!: boolean;
  @State(cmsContent => cmsContent.promoPack, {
    namespace: 'cmsContent',
  })
  readonly promoPack!: any;

  @Mutation togglePromoPackDialog!: (args: any) => void;

  get showPromoPackDialog() {
    return this.showPromoPackDialogState;
  }

  set showPromoPackDialog(value) {
    this.togglePromoPackDialog(value);
  }

  trackPromoPackCloseEvent = () => {
    this.$ua.trackGalaPackClosedEvent({
      path: this.$route.path,
    });
  };

  signUpGoogle() {
    this.$ua.trackGalaPackSignUpClickEvent({
      loginMethod: 'Google',
      path: this.$route.path,
    });
    this.$auth.loginWith('auth0', {
      params: {
        prompt: 'login',
        screen_hint: 'signup',
        connection: 'google-oauth2',
      },
    });
  }

  signUpApple() {
    this.$ua.trackGalaPackSignUpClickEvent({
      path: this.$route.path,
      loginMethod: 'Apple',
    });
    this.$auth.loginWith('auth0', {
      params: { prompt: 'login', screen_hint: 'signup', connection: 'apple' },
    });
  }

  signUpEmail() {
    this.$ua.trackGalaPackSignUpClickEvent({
      path: this.$route.path,
      loginMethod: 'Email',
    });
    this.$auth.loginWith('auth0', {
      params: {
        prompt: 'login',
        screen_hint: 'signup',
        connection: 'Username-Password-Authentication',
      },
    });
  }

  get promoPackContent() {
    return {
      headline: this.$t(`components.promoPack.headline`),
      stepsToRedeem: [
        this.$t(`components.promoPack.stepsToRedeem.1`),
        this.$t(`components.promoPack.stepsToRedeem.2`),
        this.$t(`components.promoPack.stepsToRedeem.3`),
      ],
      signInHeader: this.$t(`components.promoPack.signInHeader`),
      providers: {
        google: this.$t(`components.promoPack.providers.google`),
        apple: this.$t(`components.promoPack.providers.apple`),
        email: this.$t(`components.promoPack.providers.email`),
      },
    };
  }

  get logo() {
    return require(`@/assets/logos/gala-games-only-logo.svg`);
  }

  get poweredByGala() {
    return require(`@/assets/logos/powered-by-gala-logo.svg`);
  }

  get googleIcon() {
    return require(`@/assets/icons/icon_google.svg`);
  }

  get appleIcon() {
    return require(`@/assets/icons/icon_apple_logo.svg`);
  }
}
